<template>
    <div class="tag-bar box has-background-primary">
        <div v-if="hasLoaded" class="tags is-inline-block">
            <router-link v-for="tag in tags" :key="tag.slug" class="tag"
                         :to="{ name: 'blog.tag', params: { slug: tag.slug } }">
                {{ tag.name }}
            </router-link>
        </div>

        <div v-else>
            <b-icon icon="loading" custom-class="mdi-spin has-text-white" />
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import '../../../global/styles/_variables';

    .tag-bar {
        margin-bottom: 1rem;
        margin-top: 1rem;
        padding: 0.75rem;
        text-align: center;
        border-radius: 0;
    }
</style>

<script>
    import { mapGetters } from 'vuex';

    export default {
        data() {
            return {
                hasLoaded: false,
            };
        },

        computed: {
            ...mapGetters('blog', [
                'tags',
            ]),
        },

        watch: {
            tags(tags) {
                if (tags.length) {
                    this.hasLoaded = true;
                }
            },
        },

        mounted() {
            if (this.tags.length) {
                this.hasLoaded = true;

                return;
            }

            this.$store.dispatch('blog/loadTags', {
                exclude: 14,
                hide_empty: true,
                page_size: 20,
            });
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/blog/components/TagBar.vue